module.exports = __webpack_public_path__ + "static/img/t1-2-2.14ccb79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-2-2.png
// module id = cN0m
// module chunks = 1